export default {
  allocationBudget: "Allocation Budget",
  additionalDetails: "Additional Details",
  addProject: "Add New Project",
  editProject: "Edit Project",
  addAdvertiser: "Add New Advertiser",
  addBusinessGoal: "Add New Business Goal",
  editBusinessGoal: "Edit Business Goal",
  addBusinessGoalShort: "Add Business Goal",
  addNewPage: "Add a New Page",
  advertiserProfile: "Advertiser Profile",
  advertiserName: "Advertiser Name",
  approved: "Approved",
  noDataGenerated: "No Data Generated",
  scenarioOutputOutdated: "Output Outdated",
  accountManagement: "Account Management",
  addNewAccount: "Add New Account",
  added: "Added",
  accentColor: "Accent Color",
  backToHomepage: "Back to Homepage",
  estimatedAudienceSize: "Estimated Audience Size",
  input: "Input",
  output: "Output",
  planByBudget: "Plan by Budget",
  planByKpiGoal: "Plan by KPI Goal",
  budget: "Budget",
  homepage: "Homepage",
  colorPalette: "Color palette",
  chooseTemplateToUpdate: "Select template to update",
  last10Jobs: "Latest Generations",
  shareProject: "Share Project",
  chartConfiguration: "Chart Configuration",
  colorTheme: "Color Theme",
  scenarios: "Scenarios",
  compareScenarios: "Compare Scenarios",
  channelBudgetAllocation: "Channel Budget Allocation",
  citiesAndZips: "Cities and ZIPs Selection",
  campaignId: "Campaign ID",
  createNewPassword: "Create new password",
  chartSettings: "Chart Settings",
  countableMetrics: "Countable Metrics",
  dropZone: "Drag and drop<br />a picture here",
  dimensions: "Dimensions",
  dimensionBased: "Dimension Based",
  dateRanges: "Date Ranges",
  dateRange: "Date Range",
  emailHasBeenSent: "Email has been sent",
  editAccount: "Edit Account",
  editAdvertiser: "Edit Advertiser",
  explore: "Explore",
  forgotPasswordTitle: "Forgot password?",
  familyName: "Family",
  logoImage: "Logo",
  logoText: "CYRIS",
  newBudget: "Net Budget",
  campaignKPIS: "Campaign KPIs",
  channelSelections: "Channel Selections (optional)",
  channelExclusions: "Channel Exclusions (optional)",
  kpiGoalValue: "KPI Goal Value",
  kpiGoalValueLabel: (val: string): string => `${val} Value`,
  kpiGoal: "KPI Goal",
  skipChannelPrediction: "No more other channels are expected to be recommended in the Output",
  newBudgetAllocations: "KPIs - Net Budget Allocation",
  grossBudget: "Gross Budget",
  markets: "Markets",
  demo: "Demo",
  demos: "Demos",
  moreFilters: "More Filters",
  mainPage: "Main Page",
  mediaPlans: "Media Plans",
  name: "Name",
  noDataAvailable: "No Data Available",
  noMediaPlansAvailable: "No Media Plans Available",
  presets: "Presets",
  passwordHasBeenSuccessfullyChanged: "Password has been successfully changed",
  planModule: "Plan Module",
  plan: "Plan",
  privateTemplates: "Private Templates",
  publicTemplates: "Public Templates",
  planDetails: "Plan Details",
  signIn: "Sign in",
  ownedBy: "Owned By",
  publishDate: "Publish Date",
  lastModified: "Last Modified",
  showColumns: "Show Columns",
  startDate: "Start Date",
  endDate: "End Date",
  netBudget: "Net Budget",
  standardMetrics: "Standard Metrics",
  selectColumns: "Select Columns",
  selectPlan: "Select Plan",
  selectPlanHint: "Only Plans with min 2 Scenarios are listed",
  selectScenarios: "Select Scenarios",
  selectScenariosHint: "At least 2 Scenarios must be selected",
  selectOutputTemplate: "Select Output Template",
  summaryConfiguration: "Summary Configuration",
  summarySettings: "Summary Settings",
  tableConfiguration: "Table Configuration",
  titleResetPassword: "Reset Password",
  templateManagement: "Template Management",
  templateName: "Template name",
  projectsTemplateManagement: "Projects Template Management",
  userManagement: "User Management",
  widgetsLibrary: "Widgets Library",
  createProjectTemplate: (type: string) => `Create ${type} template`,
};
